import { useEffect, useState } from "react";

import dayjs from "dayjs";

export const createUnixTimeFromNumberOfDays = (numberOfDays) => {
  const HOURS = 24;
  const MINUTES = 60;
  const SECONDS = 60;
  return numberOfDays * HOURS * MINUTES * SECONDS;
};

const useDateRanges = () => {
  const [birthdayRange, setBirthdayRange] = useState({
    start: undefined,
    end: undefined,
  });
  const [startOrEndOfCurrentYear, setStartOrEndOfCurrentYear] =
    useState(undefined);

  useEffect(() => {
    const today = dayjs().unix();
    const todayUnix = dayjs.unix(today).hour(0).minute(0).second(0).unix();
    const todayFixedYear = dayjs.unix(todayUnix).year(1970).unix();

    const THREE_MONTHS = createUnixTimeFromNumberOfDays(90);
    const start = todayFixedYear - 1;
    const end = todayFixedYear + THREE_MONTHS;

    setBirthdayRange({ start, end });
    const currentYearEnd = new Date(new Date().getFullYear(), 11, 31);
    const convertedToUnix = Math.floor(currentYearEnd.getTime() / 1000);
    setStartOrEndOfCurrentYear(convertedToUnix);
  }, []);

  return {
    birthdayRange,
    startOrEndOfCurrentYear,
  };
};

export default useDateRanges;
